import { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames/bind';

import { timeFormatter } from '@autopass-web/domain';
import successMochi from '@autopass-web/domain/json/mochi-check.json';
import { DownloadAppBar } from '@autopass-web/mochi-component';
import { MochiLottie } from '@autopass-web/mochi-component';
import { analyticsLogger } from '@autopass-web/mochi-payment/app-loader';
import { CHAIN_STORE_NO_RECEIPT_EMAIL } from '@autopass-web/mochi-payment/config';

import styles from './index.module.scss';
import lottieStyle from './lottie.module.css';
import Sparkles from './sparkles';
import successStyle from './success.module.css';

const cx = classnames.bind(styles);

/** 
  @deprecated use SuccessPaymentModule instead
  But it still be used in libs/feature-barcode-payment/src/pages/barcode-payment/success-card.js
 */
const SuccessPayment = ({
  name,
  amount,
  discount,
  mail,
  button = null,
  shouldLeaveBefore,
  message,
  showDownloadApp = true,
}) => {
  const LottieRef = useRef('');
  const [lottieShow, setLottieShow] = useState(false);

  useEffect(() => {
    const LottiePlay = setTimeout(() => {
      setLottieShow(true);
      LottieRef.current.play();
    }, 900);

    return () => {
      clearTimeout(LottiePlay);
    };
  }, []);

  const lottieClass = cx({
    lottie: true,
    show: lottieShow,
  });

  const Message = () => {
    if (!message) return '';
    return <div className={styles.message}>{message}</div>;
  };

  const ShouldLeaveBefore = () => {
    if (!shouldLeaveBefore) return '';
    return (
      <div className={styles.leave}>
        請於 {timeFormatter(shouldLeaveBefore, 'day')} 前取車離場
      </div>
    );
  };

  const Discount = () => {
    if (!discount) return '';
    return (
      <div className={styles.discount}>
        （折扣金額 -{Math.round(Math.abs(discount))} 元）
      </div>
    );
  };

  const DownloadApp = () => {
    if (!showDownloadApp) return '';
    return (
      <CSSTransition
        appear={true}
        in={true}
        timeout={700}
        classNames={{ ...successStyle }}
      >
        <div className={styles.bar}>
          <DownloadAppBar
            onClick={() => analyticsLogger.successDownloadOnClick()}
          />
        </div>
      </CSSTransition>
    );
  };

  const Mail = () => {
    if (!mail || mail === CHAIN_STORE_NO_RECEIPT_EMAIL) return '';

    return (
      <div className={styles.mail}>
        消費明細將寄送至
        <br />
        {mail}
      </div>
    );
  };

  return (
    <div className={styles.success}>
      <Sparkles />
      <CSSTransition
        appear={true}
        in={true}
        timeout={700}
        classNames={{ ...successStyle }}
      >
        <div className={styles.card}>
          <CSSTransition
            appear={true}
            in={true}
            timeout={1000}
            classNames={{ ...lottieStyle }}
          >
            <div className={lottieClass}>
              <MochiLottie
                ref={LottieRef}
                loop={false}
                animationData={successMochi}
              />
            </div>
          </CSSTransition>
          <div className={styles.name}>{name}</div>
          <div className={styles.title}>付款完成</div>
          <div className={styles.amount}>{Math.round(amount)} 元</div>
          <Discount />
          <Message />
          <Mail />
          <ShouldLeaveBefore />
          {button}
        </div>
      </CSSTransition>
      {DownloadApp()}
    </div>
  );
};

export { SuccessPayment };
